import { put, takeEvery, all } from 'redux-saga/effects';
import * as constants from '../constants/background';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import { BackgroundService } from '../../api/background-service';
import * as coreActions from '../actions/core';
import { Notification } from '../../components/notification/main';

import Translator from '../../core/i18n';
import { IDownloadAttendance } from '../../models/action/background';
const T = Translator.create();
const _logger = Log.create('background_sagas');
const _backgroundService = new BackgroundService();

function* getActivityReport(params: any) {
    let isError = false;
    let errorList: any;
    try {
        const myYield = _backgroundService.RequestActivityReportAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData;
        }).then((response) => {
            if (isError) {
                errorList = response;
            }
        });
        yield myYield;
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

        if (!isError) {
            yield put(
                coreActions.newNotification(
                    T.t('r_gen_background_activityReport_pending'),
                    '',
                    '',
                    'topRight',
                    'success'
                )
            );
        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getQuestionBankExcelDownload(params: any) {
    let isError = false;
    let errorList: any;

    const requestParams = {
        categoryIds: params.filters.categoryIds,
        masterCourseIds: params.filters.masterCourseIds,
        courseIds: params.filters.courseIds,
        termIds: params.filters.termIds,
        examIds: params.filters.examIds,
        questionText: params.filters.questionText,
        topicIds: params.filters.topicIds,
        questionCreateDate: params.filters.questionCreatedDate,
        questionUpdateDate: params.filters.questionUpdatedDate,
        keywordIds: params.filters.keywordIds,
        Difficulties: params.filters.difficulties,
        QuestionTypes: params.filters.questionTypes,
        IsAllSelected: params.IsAllSelected,
        QuestionIdList: params.questionIdList
    }

    try {
        const myYield = _backgroundService.RequestQuestionBankExcelDownloadAsync(requestParams).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData;
        }).then((response) => {
            if (isError) {
                errorList = response;
            }
        });
        yield myYield;
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

        if (!isError) {
            yield put(
                coreActions.newNotification(
                    T.t('r_gen_background_questionBankExcelDownload_pending'),
                    '',
                    '',
                    'topRight',
                    'success'
                )
            );
        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        Notification.setNotification('error', error, 'topRight');
    }
}

function* downloadAttendance(params: IDownloadAttendance) {
    let isError = false;
    let errorList: any;
    let pageData: any;

    try {
        const _yield = _backgroundService.RequestDownloadAttendaceAsync({ AttedanceIdList: params.selectedAttendanceIds, ClassId: params.ClassId, CourseId: params.CourseId })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response: any) => {
                if (isError) {
                    errorList = response;
                } else {
                    pageData = response;
                }
            });
        yield _yield;

        if (!isError) {
            yield put(coreActions.newNotification(T.t('r_gen_background_attendanceExcelDownload_pending'), '', '', 'topRight', 'success'));

            if (params.callback) {
                params.callback("success")
            }

        } else {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        }

        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

    } catch (error: any) {
        if (params.spinnerId) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }
        Notification.setNotification('error', '' + error, 'topRight');
    }
}



function* getExamPopulatePurge(params: any): any {
    let isError = false;
    let errorList: any;

    try {
        const pageData = yield _backgroundService
            .RequestExamPopulatePurgeAsync(params.examSessionId)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData;
            }).then((response) => {
                if (isError) {
                    errorList = response;
                }
            });

        if (!isError) {
            Notification.setNotification('success', T.t('r_exam_purge_success'), 'topRight');

            params.callback();
        }

    } catch (error: any) {
        Notification.setNotification('error', T.t('r_exam_purge_error'), 'topRight');
    }
}

function* getDownloadStudentListReport(params: any): any {
    let isError = false;

    try {
        yield _backgroundService
            .RequestDownloadStudentListReportAsync(params.classId, params.courseId)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData;
            });

        if (!isError) {
            yield put(
                coreActions.newNotification(
                    T.t('r_gen_background_activityReport_pending'),
                    '',
                    '',
                    'topRight',
                    'success'
                )
            );
            if (params.callback) {
                params.callback();
            }
        }

    } catch (error: any) {
        Notification.setNotification('error', T.t('r_download_student_list_report_error'), 'topRight');
    }
}

function* UploadMultiQuestionsExcel(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        yield _backgroundService
            .RequestUploadMultiQuestionsAsync(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                }
            });

        if (!isError) {
            yield put(
                coreActions.newNotification(
                    T.t('r_upload_multi_questions_excel_success'),
                    '',
                    '',
                    'topRight',
                    'success'
                )
            );
            if (params.callback) {
                params.callback("success");
            }
        } else {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_upload_multi_questions_excel_error'), 'topRight');
            if (params.callback) {
                params.callback("error");
            }
        }

    } catch (error: any) {
        Notification.setNotification('error', T.t('r_upload_multi_questions_excel_error'), 'topRight');
        if (params.callback) {
            params.callback("error");
        }
    }
}

function* SaveUploadedQuestions(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        yield _backgroundService
            .RequestSaveUploadedQuestionsAsync(params.trackingGuid)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                    errorList = responseData;
                }
                return responseData;
            });

        if (!isError) {
            yield put(
                coreActions.newNotification(
                    T.t('r_save_uploaded_questions_success'),
                    '',
                    '',
                    'topRight',
                    'success'
                )
            );
            if (params.callback) {
                params.callback();
            }
        } else {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_save_uploaded_questions_error'), 'topRight');
        }

    } catch (error: any) {
        Notification.setNotification('error', T.t('r_save_uploaded_questions_error'), 'topRight');
    }
}

function* SendTwoFactorVerificationMail(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        yield _backgroundService
            .SendTwoFactorVerificationMail(params.target, params.isEmailAdding)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                    errorList = responseData;
                }
                return responseData;
            });

        if (!isError) {
            if (params.callback) {
                params.callback();
            }
        } else {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_send_two_factor_verification_mail_error'), 'topRight');
        }

    } catch (error: any) {
        Notification.setNotification('error', T.t('r_send_two_factor_verification_mail_error'), 'topRight');
    }
}


function* MessageToIncompleters(params: any): any {
    try {
        const response = yield _backgroundService.RequestMessageToIncompleters({
            activityId: params.activityId,
            hostAddress: window.location.hostname
        });

        if (response.status !== 200) {
            const errorList = yield response.json();
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
        } else {
            Notification.setNotification('success', T.t('r_message_to_incompleters_success'), 'topRight');
        }
    } catch (error: any) {
        Notification.setNotification('error', error, 'topRight');
    }
}

export function* watchGetActivityReport() {
    yield takeEvery(constants.actions.GET_ACTIVITY_REPORT, getActivityReport);
    return null;
}

export function* watchGetQuestionBankExcelDownload() {
    yield takeEvery(constants.actions.GET_QUESTION_BANK_EXCEL_DOWNLOAD, getQuestionBankExcelDownload);
    return null;
}

export function* watchExamPopulatePurge() {
    yield takeEvery(constants.actions.GET_EXAM_POPULATE_PURGE, getExamPopulatePurge);
    return null;
}
export function* watchGetDownloadStudentListReport() {
    yield takeEvery(constants.actions.GET_DOWNLOAD_STUDENT_LIST_REPORT, getDownloadStudentListReport);
    return null;
}

function* watchDownloadAttendance() {
    yield takeEvery(constants.actions.DOWNLOAD_ATTENDANCE, downloadAttendance);
    return null;
}

function* watchUploadMultiQuestionsExcel() {
    yield takeEvery(constants.actions.UPLOAD_MULTI_QUESTIONS_EXCEL, UploadMultiQuestionsExcel);
    return null;
}

function* watchSaveUploadedQuestions() {
    yield takeEvery(constants.actions.SAVE_UPLOADED_QUESTIONS, SaveUploadedQuestions);
    return null;
}

function* watchSendTwoFactorVerificationMail() {
    yield takeEvery(constants.actions.SEND_TWO_FACTOR_VERIFICATION_MAIL, SendTwoFactorVerificationMail);
    return null;
}

function* watchMessageToIncompleters() {
    yield takeEvery(constants.actions.MESSAGE_TO_INCOMPLETERS, MessageToIncompleters);
    return null;
}


export function* BackgroundSagas() {
    yield all([
        watchGetActivityReport(),
        watchGetQuestionBankExcelDownload(),
        watchExamPopulatePurge(),
        watchGetDownloadStudentListReport(),
        watchDownloadAttendance(),
        watchSaveUploadedQuestions(),
        watchUploadMultiQuestionsExcel(),
        watchSendTwoFactorVerificationMail(),
        watchMessageToIncompleters()
    ]);
}